const ID_TOKEN_KEY = "gy_portal_token";
const ID_API_KEY = "gy_portal_key";
const ID_TOKEN_ISSUED_TICKS_KEY = "gy_portal_token_issued_ticks";

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const getApiKey = () => {
  return window.localStorage.getItem(ID_API_KEY);
};

export const saveToken = token => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const saveApiKey = token => {
  window.localStorage.setItem(ID_API_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
  window.localStorage.removeItem(ID_TOKEN_ISSUED_TICKS_KEY);
};

export const destroyApiKey = () => {
  window.localStorage.removeItem(ID_API_KEY);
};

export const resetTokenVersion = () => {
  window.localStorage.removeItem(ID_TOKEN_ISSUED_TICKS_KEY);
};

export const saveTokenIfNewer = (token, issuedTicks) => {
    if (!token || !/^\d+$/.test(String(issuedTicks))) {
        return false;
    }

    const currentTicks = window.localStorage.getItem(ID_TOKEN_ISSUED_TICKS_KEY);
    const newTicks = String(issuedTicks).replace(/^0+/, "") || "0";
    const oldTicks = String(currentTicks || "0").replace(/^0+/, "") || "0";

    if (!currentTicks ||
        newTicks.length > oldTicks.length ||
        (newTicks.length === oldTicks.length && newTicks > oldTicks)) {
        window.localStorage.setItem(ID_TOKEN_KEY, token);
        window.localStorage.setItem(ID_TOKEN_ISSUED_TICKS_KEY, newTicks);

        return true;
    }

    return false;
};

export default { getToken, saveToken, saveTokenIfNewer, destroyToken, getApiKey, saveApiKey, destroyApiKey, resetTokenVersion };